import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import WhyChooseUs from "@/components/WhyChooseUs";
import AdvantagesPlans from "@/components/AdvantageePlans";

import ContactSection from "@/components/ContactSection";
import GoogleTestimonialsSection from "@/components/GoogleTestimonialsSection";
import FAQSection from "@/components/FAQSection";

import Footer from "@/components/Footer";

/** LocalBusiness structured data for search engines (rendered via SSR). */
const LOCAL_BUSINESS_JSONLD = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "EZ Septic Pros",
  description:
    "Veteran-owned septic services in Charlotte, NC and surrounding counties. Septic tank pumping, installation, inspection, repairs and maintenance plans.",
  url: "https://ezsepticpros.com",
  telephone: "+19809227867",
  email: "service@EZsepticPros.com",
  areaServed: [
    "Mecklenburg County NC",
    "Union County NC",
    "Cabarrus County NC",
    "Gaston County NC",
    "Iredell County NC",
    "Rowan County NC",
    "Stanly County NC",
    "Lincoln County NC",
    "Davie County NC",
  ],
  address: {
    "@type": "PostalAddress",
    addressLocality: "Charlotte",
    addressRegion: "NC",
    addressCountry: "US",
  },
  priceRange: "$$",
};

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col m-0 p-0">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(LOCAL_BUSINESS_JSONLD),
        }}
      />
      <Navigation />
      <main className="flex-1 m-0 p-0">
        <HeroSection />
        <ServicesSection />
        <WhyChooseUs />
        <GoogleTestimonialsSection />
        <div id="booking"><ContactSection /></div>
        <AdvantagesPlans />
        <FAQSection />

      </main>
      <Footer />
    </div>
  );
}
